export default {
	properties: [
		{
			text: 'Nombre/descripcion',
			key: 'name',
			type: 'text',
		},
		{
			text: 'Cantidad de cuotas',
			key: 'installments',
			type: 'number',
		},
	],
	singular_model_name_spanish: 'Cuota',
	plural_model_name_spanish: 'Cuotas',
	create_model_name_spanish: 'Nueva',
	text_delete: 'la',
}